// extracted by mini-css-extract-plugin
export default {"container":"Lq-z","brandName":"Mq-z","genderTreatment":"Nq-z","productName":"Oq-z","aboveGalleryInfo":"Pq-z","belowGalleryInfo":"Qq-z","breakLongProductName":"Rq-z"};